// extracted by mini-css-extract-plugin
module.exports = {"XAxis":"Wrapper_XAxis__3U-LJ","YAxis":"Wrapper_YAxis__vyVlm","YearLabel":"Wrapper_YearLabel__2yDve"};